const CONSTRUCTORS = [
  {
    id: 'rayz',
    isCustom: true,
    showBooking: true,
    name: 'Rayz',
    motto: '',
    description:
      'Rayz Residence is a modern 7-story residential building on S. Chiloyan Street, located in a well-established neighborhood with views of Hagtanak Park and Mount Ararat. The complex features 42 comfortable, efficiently planned apartments, each with individual gas heating. It includes two levels of underground parking, a spacious high-ceiling lobby, and aluminum windows with sound and heat insulation. Completion is scheduled for the end of 2025.',
    logo: '/constructorsMedia/thumbnails/rayz.jpg',
    coverImageUrl: '/constructorsMedia/coverImages/rayz.jpg',
    startDate: '2024 January',
    endDate: '2026 Summer',
    numberOfUnits: 270,
    location: null,
    phone: '+374 44 55 55 08',
    yoEstateUrl: 'https://yoestate.me/en/collections/rayz/nfts',
    gallery: [
      '/constructorsMedia/gallery/rayz/11.jpeg',
      '/constructorsMedia/gallery/rayz/12.jpeg',
      '/constructorsMedia/gallery/rayz/13.jpeg',
      '/constructorsMedia/gallery/rayz/14.jpeg',
      '/constructorsMedia/gallery/rayz/15.jpeg',
      '/constructorsMedia/gallery/rayz/1.jpeg',
      '/constructorsMedia/gallery/rayz/2.jpeg',
      '/constructorsMedia/gallery/rayz/3.jpeg',
      '/constructorsMedia/gallery/rayz/4.jpeg',
      '/constructorsMedia/gallery/rayz/5.jpeg',
      '/constructorsMedia/gallery/rayz/6.jpeg',
      '/constructorsMedia/gallery/rayz/8.jpeg',
      '/constructorsMedia/gallery/rayz/9.jpeg',
      '/constructorsMedia/gallery/rayz/10.jpeg',
    ],
    additionalInformation: [
      {
        id: '1',
        title: 'Construction Time',
        value: '2024 January - 2026 Summer',
      },
      {
        id: '2',
        title: 'Floor Area',
        value: '84,8 sqm',
      },
      {
        id: '5',
        title: 'Floor',
        value: '2nd',
      },
      {
        id: '3',
        title: 'Number Of Rooms',
        value: '3',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Not available',
      },
    ],
    details: [
      {
        id: '1',
        title: 'Floor Area',
        value: '84,8 sqm',
      },
      {
        id: '2',
        title: 'Number of Rooms',
        value: '3',
      },
      {
        id: '3',
        title: 'Floor',
        value: '2nd',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Not available',
      },
    ],
    address: {
      name: 'Arabkir, St. Chiloyan 18',
    },
    roomUrl: '/copia/constructors/13/3d',
    price: { amount: '838,000', per: '1m²', currency: 'AMD' },
  },
  {
    id: 'capital-signature',
    isCustom: true,
    showBooking: true,
    name: 'Capital Signature',
    motto: '',
    description:
      'Arshakunyats Residence is a premium residential complex in the center of Yerevan, combining modern design with everyday comfort. The three 24-story buildings feature bright, well-planned apartments with full glass façades that fill the spaces with natural light. With underground parking and convenient commercial areas, it offers a comfortable and stylish lifestyle for modern living.',
    logo: '/constructorsMedia/thumbnails/capital-signature.jpg',
    coverImageUrl: '/constructorsMedia/coverImages/capital-signature.jpg',
    startDate: '2025 June',
    endDate: '2030 June',
    location: null,
    phone: '+374 44 610 109',
    gallery: [],
    additionalInformation: [
      {
        id: '1',
        title: 'Construction Time',
        value: '2025 June - 2030 June',
      },
      {
        id: '2',
        title: 'Floor Area',
        value: '70,5 sqm',
      },
      {
        id: '3',
        title: 'Number of Rooms',
        value: '2-3',
      },
      {
        id: '4',
        title: 'Floor',
        value: '22nd',
      },
      {
        id: '5',
        title: 'Income tax refund',
        value: 'Not available',
      },
    ],
    details: [
      {
        id: '1',
        title: 'Floor Area',
        value: '70,5 sqm',
      },
      {
        id: '2',
        title: 'Number of Rooms',
        value: '2-3',
      },
      {
        id: '3',
        title: 'Floor',
        value: '22nd',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Not available',
      },
    ],
    address: {
      name: '12 Sevan Street',
    },
    numberOfUnits: 270,
    roomUrl: '/copia/constructors/8/3d',
    yoEstateUrl: 'https://yoestate.me/en/collections/capital-signature/nfts',
    // price: { amount: '580', per: '1m²', currency: 'FTN' },
    price: { amount: '1,100,000', per: '1m²', currency: 'AMD' },
  },
  {
    id: 'capital-prime',
    isCustom: true,
    showBooking: true,
    name: 'Capital Prime',
    motto: '',
    description:
      'Arshakunyats Residence is a premium residential complex in the center of Yerevan, combining modern design with everyday comfort. The three 24-story buildings feature bright, well-planned apartments with full glass façades that fill the spaces with natural light. With underground parking and convenient commercial areas, it offers a comfortable and stylish lifestyle for modern living.',
    logo: '/constructorsMedia/thumbnails/capital-prime.jpg',
    coverImageUrl: '/constructorsMedia/coverImages/capital-prime.jpg',
    startDate: '2025 June',
    endDate: '2030 June',
    location: null,
    phone: '+374 44 610 109',
    gallery: [],
    additionalInformation: [
      {
        id: '1',
        title: 'Construction Time',
        value: '2025 June - 2030 June',
      },
      {
        id: '2',
        title: 'Floor Area',
        value: '65,2 sqm',
      },
      {
        id: '3',
        title: 'Number of Rooms',
        value: '2',
      },
      {
        id: '4',
        title: 'Floor',
        value: '16th',
      },
      {
        id: '5',
        title: 'Income tax refund',
        value: 'Not available',
      },
    ],
    details: [
      {
        id: '1',
        title: 'Floor Area',
        value: '65,2 sqm',
      },
      {
        id: '2',
        title: 'Number of Rooms',
        value: '2',
      },
      {
        id: '3',
        title: 'Floor',
        value: '16th',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Not available',
      },
    ],
    address: {
      name: '12 Sevan Street',
    },
    numberOfUnits: 270,
    roomUrl: '/copia/constructors/11/3d',
    yoEstateUrl: 'https://yoestate.me/en/collections/capital-prime/nfts',
    // price: { amount: '504', per: '1m²', currency: 'FTN' },
    price: { amount: '870,000', per: '1m²', currency: 'AMD' },
  },
  {
    id: 'clubhouse',
    isCustom: true,
    showBooking: true,
    name: 'Clubhouse',
    motto: '',
    description:
      'Clubhouse is a premium 5-story residential complex that blends modern luxury with comfort and calm. Located just minutes from Yerevan’s Little Center, it offers stylish, carefully designed apartments, panoramic views, and fresh air—away from the city noise but close to everything. The furnished rooftop terrace opens to breathtaking views of Mount Ararat, creating the perfect space to relax or entertain. At Clubhouse, every detail is designed to elevate your everyday living.',
    logo: '/constructorsMedia/thumbnails/clubhouse.jpg',
    coverImageUrl: '/constructorsMedia/coverImages/clubhouse.jpg',
    startDate: '2023 September',
    endDate: 'Completed',
    location: null,
    phone: '+374 60 778 122',
    gallery: [
      //   '/constructorsMedia/gallery/clubhouse/1.jpg',
      //   '/constructorsMedia/gallery/clubhouse/2.jpg',
      //   '/constructorsMedia/gallery/clubhouse/3.jpg',
      //   '/constructorsMedia/apartments/clubhouse-1.jpg',
      //   '/constructorsMedia/apartments/clubhouse-2.jpg',
      //   '/constructorsMedia/apartments/clubhouse-3.jpg',
      //   '/constructorsMedia/apartments/clubhouse-4.jpg',
      //   '/constructorsMedia/gallery/clubhouse/4.jpg',
      //   '/constructorsMedia/gallery/clubhouse/5.jpg',
      //   '/constructorsMedia/gallery/clubhouse/6.jpg',
      //   '/constructorsMedia/apartments/clubhouse-5.jpg',
      //   '/constructorsMedia/apartments/clubhouse-6.jpg',
    ],
    additionalInformation: [
      {
        id: '5',
        title: 'Construction Time',
        value: '2023 September - Completed',
      },
      {
        id: '1',
        title: 'Floor Area',
        value: '63,6 sqm',
      },
      {
        id: '2',
        title: 'Number of Rooms',
        value: '2',
      },
      {
        id: '3',
        title: 'Floor',
        value: '6th',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Not available',
      },
    ],
    details: [
      {
        id: '1',
        title: 'Floor Area',
        value: '63,6 sqm',
      },
      {
        id: '2',
        title: 'Number of Rooms',
        value: '2',
      },
      {
        id: '3',
        title: 'Floor',
        value: '6th',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Not available',
      },
    ],
    address: {
      name: 'G. Hovsepyan 22/11',
    },
    numberOfUnits: 270,
    roomUrl: '/copia/constructors/5/3d',
    yoEstateUrl: 'https://yoestate.me/en/collections/clubhouse/nfts',
    price: { amount: '888,000', per: '1m²', currency: 'AMD' },
    // price: { amount: '538', per: '1m²', currency: 'FTN' },
  },
  {
    id: 'capital-elite',
    isCustom: true,
    showBooking: true,
    name: 'Capital Elite',
    motto: '',
    description:
      'Arshakunyats Residence is a premium residential complex in the center of Yerevan, combining modern design with everyday comfort. The three 24-story buildings feature bright, well-planned apartments with full glass façades that fill the spaces with natural light. With underground parking and convenient commercial areas, it offers a comfortable and stylish lifestyle for modern living.',
    logo: 'https://fv-media.storage.googleapis.com/real_estate_constructor_logo/3f71130d7d28b2a580aea9fea00be23c.jpg',
    coverImageUrl: '/constructorsMedia/coverImages/capital-elite.jpg',
    startDate: '2025 June',
    endDate: '2030 June',
    location: null,
    phone: '+374 44 610 109',
    gallery: [
      'https://fv-media.storage.googleapis.com/res_constructor_detail_gallery/4ab803de55f4b681ec8b3b256e473d0c.jpg',
      'https://fv-media.storage.googleapis.com/res_constructor_detail_gallery/1b51f622c9873cc3a43de9e4c1d7bcca.jpg',
      'https://fv-media.storage.googleapis.com/res_constructor_detail_gallery/f2d8a7ab63c7f665232c57293dafd018.jpg',
    ],
    additionalInformation: [
      {
        id: '1',
        title: 'Construction Time',
        value: '2025 June - 2030 June',
      },
      {
        id: '2',
        title: 'Floor Area',
        value: '68,2 sqm',
      },
      {
        id: '3',
        title: 'Number of Rooms',
        value: '2',
      },
      {
        id: '4',
        title: 'Floor',
        value: '16th',
      },
      {
        id: '5',
        title: 'Income tax refund',
        value: 'Not available',
      },
    ],
    details: [
      {
        id: '1',
        title: 'Floor Area',
        value: '68,2 sqm',
      },
      {
        id: '2',
        title: 'Number of Rooms',
        value: '2',
      },
      {
        id: '3',
        title: 'Floor',
        value: '16th',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Not available',
      },
    ],
    address: {
      name: '12 Sevan Street',
    },
    numberOfUnits: 270,
    roomUrl: '/copia/constructors/7/3d',
    yoEstateUrl: 'https://yoestate.me/en/collections/capital-elite/nfts',
    // price: { amount: '504', per: '1m²', currency: 'FTN' },
    price: { amount: '869,000', per: '1m²', currency: 'AMD' },
  },
  {
    id: 'capital-grande',
    isCustom: true,
    showBooking: true,
    name: 'Capital Grande',
    motto: '',
    description:
      'Arshakunyats Residence is a premium residential complex in the center of Yerevan, combining modern design with everyday comfort. The three 24-story buildings feature bright, well-planned apartments with full glass façades that fill the spaces with natural light. With underground parking and convenient commercial areas, it offers a comfortable and stylish lifestyle for modern living.',
    logo: 'https://fv-media.storage.googleapis.com/real_estate_constructor_logo/b57039a96b47d35e30bb70062010c0a1.jpg',
    coverImageUrl: '/constructorsMedia/coverImages/capital-grande.jpg',
    startDate: '2025 June',
    endDate: '2030 June',
    location: null,
    phone: '+374 44 610 109',
    gallery: [
      'https://fv-media.storage.googleapis.com/res_constructor_detail_gallery/59a10d0cd1449813a695a6975d65f688.jpg',
      'https://fv-media.storage.googleapis.com/res_constructor_detail_gallery/c903eb9cfb7e25aeb6b512bd5e87973d.jpg',
      'https://fv-media.storage.googleapis.com/res_constructor_detail_gallery/68f0a8354b8284c9ffa2c6b900a29c53.jpg',
    ],
    additionalInformation: [
      {
        id: '1',
        title: 'Construction Time',
        value: '2025 June - 2030 June',
      },
      {
        id: '2',
        title: 'Floor Area',
        value: '111 sqm',
      },
      {
        id: '3',
        title: 'Number of Rooms',
        value: '2-3',
      },
      {
        id: '4',
        title: 'Floor',
        value: '16th',
      },
      {
        id: '5',
        title: 'Income tax refund',
        value: 'Not available',
      },
    ],
    details: [
      {
        id: '1',
        title: 'Floor Area',
        value: '111 sqm',
      },
      {
        id: '2',
        title: 'Number of Rooms',
        value: '2-3',
      },
      {
        id: '3',
        title: 'Floor',
        value: '16th',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Not available',
      },
    ],
    address: {
      name: '12 Sevan Street',
    },
    numberOfUnits: 270,
    roomUrl: '/copia/constructors/9/3d',
    yoEstateUrl: 'https://yoestate.me/en/collections/capital-grande/nfts',
    // price: { amount: '504', per: '1m²', currency: 'FTN' },
    price: { amount: '870,000', per: '1m²', currency: 'AMD' },
  },
  {
    id: 'capital-nova',
    isCustom: true,
    showBooking: true,
    name: 'Capital Nova',
    motto: '',
    description:
      'Arshakunyats Residence is a premium residential complex in the center of Yerevan, combining modern design with everyday comfort. The three 24-story buildings feature bright, well-planned apartments with full glass façades that fill the spaces with natural light. With underground parking and convenient commercial areas, it offers a comfortable and stylish lifestyle for modern living.',
    logo: 'https://fv-media.storage.googleapis.com/real_estate_constructor_logo/36d293b217d69bf72436d26722d6db3d.jpg',
    coverImageUrl: '/constructorsMedia/coverImages/capital-nova.jpg',
    startDate: '2025 June',
    endDate: '2030 June',
    location: null,
    phone: '+374 44 610 109',
    gallery: [
      'https://fv-media.storage.googleapis.com/res_constructor_detail_gallery/56347ae22a998bd59f5b86ebe2225350.jpg',
      'https://fv-media.storage.googleapis.com/res_constructor_detail_gallery/17da592dc2df48e52d100d63bcf28cd2.jpg',
      'https://fv-media.storage.googleapis.com/res_constructor_detail_gallery/eb7ee038bc849c3770ea1fa5edd3395d.jpg',
    ],
    additionalInformation: [
      {
        id: '1',
        title: 'Construction Time',
        value: '2025 June - 2030 June',
      },
      {
        id: '2',
        title: 'Floor Area',
        value: '59,3 sqm',
      },
      {
        id: '3',
        title: 'Number of Rooms',
        value: '1',
      },
      {
        id: '4',
        title: 'Floor',
        value: '17th',
      },
      {
        id: '5',
        title: 'Income tax refund',
        value: 'Not available',
      },
    ],
    details: [
      {
        id: '1',
        title: 'Floor Area',
        value: '59,3 sqm',
      },
      {
        id: '2',
        title: 'Number of Rooms',
        value: '1',
      },
      {
        id: '3',
        title: 'Floor',
        value: '17th',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Not available',
      },
    ],
    address: {
      name: '12 Sevan Street',
    },
    numberOfUnits: 270,
    roomUrl: '/copia/constructors/10/3d',
    yoEstateUrl: 'https://yoestate.me/en/collections/capital-nova/nfts',
    // price: { amount: '504', per: '1m²', currency: 'FTN' },
    price: { amount: '730,000', per: '1m²', currency: 'AMD' },
  },

  {
    id: 'rayz-lume',
    isCustom: true,
    showBooking: true,
    name: 'Rayz Lume',
    motto: '',
    description:
      'Rayz Residence is a modern 7-story residential building on S. Chiloyan Street, located in a well-established neighborhood with views of Hagtanak Park and Mount Ararat. The complex features 42 comfortable, efficiently planned apartments, each with individual gas heating. It includes two levels of underground parking, a spacious high-ceiling lobby, and aluminum windows with sound and heat insulation. Completion is scheduled for the end of 2025.',
    logo: '/constructorsMedia/thumbnails/rayz.jpg',
    coverImageUrl:
      'https://fv-media.storage.googleapis.com/res_constructor_detail_cover_image/87c9cbfb9a2e5bf9b6890abff208edb9.jpg',
    startDate: '2024 January',
    endDate: '2026 Summer',
    numberOfUnits: 270,
    location: null,
    phone: '+374 44 55 55 08',
    yoEstateUrl: 'https://yoestate.me/en/collections/rayz-lume/nfts',
    gallery: [
      'https://fv-media.storage.googleapis.com/res_constructor_detail_gallery/c398a0df661851515f6f7598fa594e03.jpg',
      'https://fv-media.storage.googleapis.com/res_constructor_detail_gallery/9364941e331c2752f6d405da89adb62a.jpg',
      'https://fv-media.storage.googleapis.com/res_constructor_detail_gallery/ac9762041881bb6e1bce0977230794b0.jpg',
      'https://fv-media.storage.googleapis.com/res_constructor_detail_gallery/0aad6e58cf15b226a877ba4a5e728942.jpg',
      'https://fv-media.storage.googleapis.com/res_constructor_detail_gallery/d159ab24f4d9f5c4a0cfd803134d0f44.jpg',
    ],
    additionalInformation: [
      {
        id: '1',
        title: 'Construction Time',
        value: '2024 January - 2026 Summer',
      },
      {
        id: '2',
        title: 'Floor Area',
        value: '45,2 sqm',
      },
      {
        id: '5',
        title: 'Floor',
        value: '2nd',
      },
      {
        id: '3',
        title: 'Number Of Rooms',
        value: '2',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Not available',
      },
    ],
    details: [
      {
        id: '1',
        title: 'Floor Area',
        value: '45,2 sqm',
      },
      {
        id: '2',
        title: 'Number of Rooms',
        value: '2',
      },
      {
        id: '3',
        title: 'Floor',
        value: '2nd',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Not available',
      },
    ],
    address: {
      name: 'Arabkir, St. Chiloyan 18',
    },
    roomUrl: '/copia/constructors/6/3d',
    // price: { amount: '545', per: '1m²', currency: 'FTN' },
    price: { amount: '905,000', per: '1m²', currency: 'AMD' },
  },
  {
    id: 'rayz-glow',
    isCustom: true,
    showBooking: true,
    name: 'Rayz Glow',
    motto: '',
    description:
      'Rayz Residence is a modern 7-story residential building on S. Chiloyan Street, located in a well-established neighborhood with views of Hagtanak Park and Mount Ararat. The complex features 42 comfortable, efficiently planned apartments, each with individual gas heating. It includes two levels of underground parking, a spacious high-ceiling lobby, and aluminum windows with sound and heat insulation. Completion is scheduled for the end of 2025.',
    logo: '/constructorsMedia/thumbnails/rayz.jpg',
    coverImageUrl:
      'https://fv-media.storage.googleapis.com/res_constructor_detail_cover_image/de9f1d72acf97d1e2a6aa3a986e915b8.jpg',
    startDate: '2024 January',
    endDate: '2026 Summer',
    numberOfUnits: 270,
    location: null,
    phone: '+374 44 55 55 08',
    yoEstateUrl: 'https://yoestate.me/en/collections/rayz-glow/nfts',
    gallery: [
      'https://fv-media.storage.googleapis.com/res_constructor_detail_gallery/bffc9de9f3b580c377a31fefdad99ac1.jpg',
      'https://fv-media.storage.googleapis.com/res_constructor_detail_gallery/ef9271e8724e5516ae79db148be6b94a.jpg',
      'https://fv-media.storage.googleapis.com/res_constructor_detail_gallery/558ae437e4a3ab4f285a7d565cef1a8f.jpg',
      'https://fv-media.storage.googleapis.com/res_constructor_detail_gallery/e3f77be1d7e8ef12739e28212c0e19d0.jpg',
      'https://fv-media.storage.googleapis.com/res_constructor_detail_gallery/6a3e6678219db3b0ba7521aa1aa92453.jpg',
    ],
    additionalInformation: [
      {
        id: '1',
        title: 'Construction Time',
        value: '2024 January - 2026 Summer',
      },
      {
        id: '2',
        title: 'Floor Area',
        value: '46 sqm',
      },
      {
        id: '5',
        title: 'Floor',
        value: '3rd',
      },
      {
        id: '3',
        title: 'Number Of Rooms',
        value: '2',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Not available',
      },
    ],
    details: [
      {
        id: '1',
        title: 'Floor Area',
        value: '46 sqm',
      },
      {
        id: '2',
        title: 'Number of Rooms',
        value: '2',
      },
      {
        id: '3',
        title: 'Floor',
        value: '3rd',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Not available',
      },
    ],
    address: {
      name: 'Arabkir, St. Chiloyan 18',
    },
    roomUrl: '/copia/constructors/12/3d',
    // price: { amount: '545', per: '1m²', currency: 'FTN' },
    price: { amount: '900,000', per: '1m²', currency: 'AMD' },
  },

  {
    id: 'binghatti-gardenia',
    isCustom: true,
    showBooking: true,
    name: 'Binghatti Gardenia',
    motto: '',
    description: '',
    logo: '/constructorsMedia/thumbnails/binghatti-gardenia.jpg',
    coverImageUrl: '/constructorsMedia/coverImages/binghatti-gardenia.jpg',
    startDate: '2023 May',
    endDate: '2024 March',
    numberOfUnits: 270,
    location: null,
    phone: '+971 800 15',
    yoEstateUrl: 'https://yoestate.me/en/collections/binghatti-gardenia/nfts',
    gallery: [],
    additionalInformation: [
      {
        id: '1',
        title: 'Construction Time',
        value: '2023 May - Completed',
      },
      {
        id: '2',
        title: 'Floor Area',
        value: '105 sqm',
      },
      {
        id: '5',
        title: 'Floor',
        value: '33rd',
      },
      {
        id: '3',
        title: 'Number Of Rooms',
        value: '2',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Not available',
      },
    ],
    details: [
      {
        id: '1',
        title: 'Floor Area',
        value: '105 sqm',
      },
      {
        id: '2',
        title: 'Number of Rooms',
        value: '2',
      },
      {
        id: '3',
        title: 'Floor',
        value: '33rd',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Not available',
      },
    ],
    address: {
      name: 'Jumeirah Village Circle - Dubai - United Arab Emirates',
    },
    roomUrl: '/copia/constructors/19/3d',
    // price: { amount: '545', per: '1m²', currency: 'FTN' },
    price: { amount: '1,970,000', per: '1m²', currency: 'AMD' },
  },
  {
    id: 'address-beach-resort',
    isCustom: true,
    showBooking: true,
    name: 'Address Beach Resort',
    motto: '',
    description:
      'Address Beach Resort is a luxurious 5-star hotel in JBR, Dubai, boasting stunning views of the Bluewaters Island and Ain Dubai. This iconic Dubai beach resort features two 77-story towers with luxurious hotel rooms. Enjoy world-class amenities, including the highest outdoor infinity pool in the world – a Guinness World Record holder – gourmet dining at beachfront restaurants , pampering spa treatments, and direct access to JBR beach.',
    logo: '/constructorsMedia/thumbnails/address-beach.jpg',
    coverImageUrl: '/constructorsMedia/coverImages/address-beach.jpg',
    startDate: '2016 December',
    endDate: '2020 December',
    numberOfUnits: 270,
    location: null,
    phone: '+97148798888',
    yoEstateUrl: 'https://yoestate.me/en/collections/address-beach-resort/nfts',
    gallery: [
      '/constructorsMedia/gallery/address-beach-resort/281023122.jpg',
      '/constructorsMedia/gallery/address-beach-resort/281023141.jpg',
      '/constructorsMedia/gallery/address-beach-resort/281024928.jpg',
      '/constructorsMedia/gallery/address-beach-resort/400547680.jpg',
      '/constructorsMedia/gallery/address-beach-resort/400547683.jpg',
    ],
    additionalInformation: [
      {
        id: '1',
        title: 'Construction Time',
        value: '2016 December - Completed',
      },
      {
        id: '2',
        title: 'Floor Area',
        value: '110,18 sqm',
      },
      {
        id: '5',
        title: 'Floor',
        value: '77th',
      },
      {
        id: '3',
        title: 'Number Of Rooms',
        value: '3',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Not available',
      },
    ],
    details: [
      {
        id: '1',
        title: 'Floor Area',
        value: '110,18 sqm',
      },
      {
        id: '2',
        title: 'Number of Rooms',
        value: '3',
      },
      {
        id: '3',
        title: 'Floor',
        value: '77th',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Not available',
      },
    ],
    address: {
      name: 'The Walk - Jumeirah Beach Residence - Dubai - United Arab Emirates',
    },
    roomUrl: '/copia/constructors/15/3d',
    price: { amount: '6,930,000', per: '1m²', currency: 'AMD' },
  },
  {
    id: 'business-hub',
    isCustom: true,
    showBooking: true,
    name: 'Business Hub',
    motto: '',
    description:
      'Business Hub is a modern commercial area with 341 sqm of flexible office space. It is ideal for companies, startups, and service providers looking for a workspace that supports both focus and teamwork. The layout can be adapted for private offices, meeting rooms, and shared work areas, allowing businesses to set up according to their needs. Business Hub offers a clean and professional environment, making it a solid base for daily operations and future growth.',
    logo: '/constructorsMedia/thumbnails/business-hub.png',
    coverImageUrl: '/constructorsMedia/coverImages/business-hub.jpg',
    startDate: '',
    endDate: '',
    numberOfUnits: 270,
    location: null,
    phone: '+374 44 40 44 40',
    yoEstateUrl: 'https://yoestate.me/en/collections/business-hub/nfts',
    gallery: [
      '/constructorsMedia/gallery/business-hub/1.jpeg',
      '/constructorsMedia/gallery/business-hub/2.jpeg',
      '/constructorsMedia/gallery/business-hub/3.jpeg',
      '/constructorsMedia/gallery/business-hub/4.jpeg',
      '/constructorsMedia/gallery/business-hub/5.jpeg',
    ],
    additionalInformation: [
      {
        id: '2',
        title: 'Floor Area',
        value: '341 sqm',
      },
      {
        id: '5',
        title: 'Floor',
        value: '-1',
      },
    ],
    details: [
      {
        id: '1',
        title: 'Floor Area',
        value: '341 sqm',
      },
      {
        id: '2',
        title: 'Number of Rooms',
        value: '-',
      },
      {
        id: '3',
        title: 'Floor',
        value: '-1',
      },
    ],
    address: {
      name: '"Piazza Grande" Business center, 10 Vazgen Sargsyan St.',
    },
    roomUrl: '/copia/constructors/17/3d',
    // price: { amount: '545', per: '1m²', currency: 'FTN' },
    price: { amount: '1,890,000', per: '1m²', currency: 'AMD' },
  },
  {
    id: 'zoar',
    isCustom: true,
    showBooking: true,
    name: 'Zoar',
    motto: '',
    description: `Zoar Residential Complex is a modern 15-story building situated in a well-established neighborhood, offering 106 spacious apartments designed for comfortable, high-quality living. Each apartment features individual gas heating and high-quality aluminum windows with heat insulation, ensuring both energy efficiency and comfort. 
    The building includes two underground parking levels and 24/7 security services. Nearby amenities include schools, kindergartens, and easy access to public transportation.`,
    logo: '/constructorsMedia/thumbnails/zoar.jpg',
    coverImageUrl: '/constructorsMedia/coverImages/zoar.jpg',
    startDate: '',
    endDate: '',
    numberOfUnits: 270,
    location: null,
    phone: '+374 41 22 12 05',
    yoEstateUrl: 'https://yoestate.me/en/collections/zoar/nfts',
    gallery: [
      '/constructorsMedia/gallery/zoar/1.png',
      '/constructorsMedia/gallery/zoar/2.png',
      '/constructorsMedia/gallery/zoar/3.png',
      '/constructorsMedia/gallery/zoar/4.png',
      '/constructorsMedia/gallery/zoar/5.png',
      '/constructorsMedia/gallery/zoar/6.png',
      '/constructorsMedia/gallery/zoar/7.png',
      '/constructorsMedia/gallery/zoar/8.png',
      '/constructorsMedia/gallery/zoar/9.png',
      '/constructorsMedia/gallery/zoar/10.png',
      '/constructorsMedia/gallery/zoar/11.png',
      '/constructorsMedia/gallery/zoar/12.png',
      '/constructorsMedia/gallery/zoar/13.png',
      '/constructorsMedia/gallery/zoar/14.png',
      '/constructorsMedia/gallery/zoar/15.png',
      '/constructorsMedia/gallery/zoar/16.png',
      '/constructorsMedia/gallery/zoar/17.png',
      '/constructorsMedia/gallery/zoar/18.png',
      '/constructorsMedia/gallery/zoar/19.png',
      '/constructorsMedia/gallery/zoar/20.png',
      '/constructorsMedia/gallery/zoar/21.png',
    ],
    additionalInformation: [
      {
        id: '1',
        title: 'Delivery Time',
        value: '2025 Autumn',
      },
      {
        id: '2',
        title: 'Floor Area',
        value: '115,2 sqm',
      },
      {
        id: '5',
        title: 'Floor',
        value: '14th',
      },
      {
        id: '3',
        title: 'Number Of Rooms',
        value: '3',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Available',
      },
    ],
    details: [
      {
        id: '1',
        title: 'Floor Area',
        value: '115,2 sqm',
      },
      {
        id: '2',
        title: 'Number of Rooms',
        value: '3',
      },
      {
        id: '3',
        title: 'Floor',
        value: '14th',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Available',
      },
    ],
    address: {
      name: 'Paruyr Sevak Block 4th Street, 2',
    },
    roomUrl: '/copia/constructors/18/3d',
    // price: { amount: '545', per: '1m²', currency: 'FTN' },
    price: { amount: '565,000', per: '1m²', currency: 'AMD' },
  },
  {
    id: 'clubhouse-spark',
    isCustom: true,
    showBooking: true,
    name: 'Clubhouse Spark',
    motto: '',
    description:
      'Clubhouse is a premium 5-story residential complex that blends modern luxury with comfort and calm. Located just minutes from Yerevan’s Little Center, it offers stylish, carefully designed apartments, panoramic views, and fresh air—away from the city noise but close to everything. The furnished rooftop terrace opens to breathtaking views of Mount Ararat, creating the perfect space to relax or entertain. At Clubhouse, every detail is designed to elevate your everyday living.',
    logo: '/constructorsMedia/thumbnails/clubhouse-spark.jpg',
    coverImageUrl: '/constructorsMedia/coverImages/clubhouse-spark.jpg',
    startDate: '2023 September',
    endDate: 'Completed',
    location: null,
    phone: '+374 60 778 122',
    gallery: [
      '/constructorsMedia/gallery/clubhouse-spark/14.jpg',
      '/constructorsMedia/gallery/clubhouse-spark/17.jpg',
      '/constructorsMedia/gallery/clubhouse-spark/16.jpg',
    ],
    additionalInformation: [
      {
        id: '5',
        title: 'Construction Time',
        value: '2023 September - Completed',
      },
      {
        id: '1',
        title: 'Floor Area',
        value: '63,6 sqm',
      },
      {
        id: '2',
        title: 'Number of Rooms',
        value: '2',
      },
      {
        id: '3',
        title: 'Floor',
        value: '4th',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Not available',
      },
    ],
    details: [
      {
        id: '1',
        title: 'Floor Area',
        value: '63,6 sqm',
      },
      {
        id: '2',
        title: 'Number of Rooms',
        value: '2',
      },
      {
        id: '3',
        title: 'Floor',
        value: '4',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Not available',
      },
    ],
    address: {
      name: 'G. Hovsepyan 22/11',
    },
    numberOfUnits: 270,
    roomUrl: '/copia/constructors/14/3d',
    yoEstateUrl: 'https://yoestate.me/en/collections/clubhouse-spark/nfts',
    price: { amount: '840,000', per: '1m²', currency: 'AMD' },
    // price: { amount: '538', per: '1m²', currency: 'FTN' },
  },
  {
    id: 'movenpick-resort-tsaghkadzor',
    isCustom: true,
    showBooking: true,
    name: 'Movenpick Resort Tsaghkadzor',
    motto: '',
    description: `Mövenpick Resort Tsaghkadzor is a top-quality hotel located in Armenia’s beautiful mountain area. It combines Swiss hospitality with the natural beauty and history of Tsaghkadzor. The hotel has 198 large and comfortable rooms, designed for both travelers and business guests. Each room has modern furniture, great views, and all the features you expect from a well-known international hotel.`,
    logo: '/constructorsMedia/thumbnails/movenpick.jpg',
    coverImageUrl: '/constructorsMedia/coverImages/movenpick.jpg',
    startDate: '',
    endDate: '2026 December',
    location: null,
    phone: '+374 95 95 9999',
    gallery: [
      '/constructorsMedia/gallery/movenpick/PERSP Movenpick Tsaghkadzor PILOT 2024-08-08 (1).jpg',
      '/constructorsMedia/gallery/movenpick/PERSP Movenpick Tsaghkadzor PILOT 2024-08-08 (2) (1).jpg',
      '/constructorsMedia/gallery/movenpick/PERSP Movenpick Tsaghkadzor PILOT 2024-08-08 (3).jpg',
      '/constructorsMedia/gallery/movenpick/PERSP Movenpick Tsaghkadzor PILOT 2024-08-08 (4).jpg',
      '/constructorsMedia/gallery/movenpick/PERSP Movenpick Tsaghkadzor PILOT 2024-08-08 (5).jpg',
      '/constructorsMedia/gallery/movenpick/PERSP Movenpick Tsaghkadzor PILOT 2024-08-08 (6).jpg',
      '/constructorsMedia/gallery/movenpick/PERSP Movenpick Tsaghkadzor PILOT 2024-08-08 (7).jpg',
      '/constructorsMedia/gallery/movenpick/PERSP Movenpick Tsaghkadzor PILOT 2024-08-08 (8).jpg',
      '/constructorsMedia/gallery/movenpick/PERSP Movenpick Tsaghkadzor PILOT 2024-08-08 (9).jpg',
      '/constructorsMedia/gallery/movenpick/PERSP Movenpick Tsaghkadzor PILOT 2024-08-08 (10).jpg',
      '/constructorsMedia/gallery/movenpick/PERSP Movenpick Tsaghkadzor PILOT 2024-08-08 (11).jpg',
      '/constructorsMedia/gallery/movenpick/PERSP Movenpick Tsaghkadzor PILOT 2024-08-08 (12) (1).jpg',
      '/constructorsMedia/gallery/movenpick/PERSP_Movenpick_Tsaghkadzor_LOBBY_2025_04_18_without_logo_1.jpg',
      '/constructorsMedia/gallery/movenpick/PERSP_Movenpick_Tsaghkadzor_LOBBY_2025_04_18_without_logo_2.jpg',
      '/constructorsMedia/gallery/movenpick/PERSP_Movenpick_Tsaghkadzor_LOBBY_2025_04_18_without_logo_3 (1).jpg',
      '/constructorsMedia/gallery/movenpick/PERSP_Movenpick_Tsaghkadzor_LOBBY_2025_04_18_without_logo_4.jpg',
      '/constructorsMedia/gallery/movenpick/PERSP_Movenpick_Tsaghkadzor_LOBBY_2025_04_18_without_logo_5.jpg',
      '/constructorsMedia/gallery/movenpick/PERSP_Movenpick_Tsaghkadzor_LOBBY_2025_04_18_without_logo_6.jpg',
      '/constructorsMedia/gallery/movenpick/PERSP_Movenpick_Tsaghkadzor_LOBBY_2025_04_18_without_logo_7.jpg',
      '/constructorsMedia/gallery/movenpick/PERSP_Movenpick_Tsaghkadzor_LOBBY_2025_04_18_without_logo_8.jpg',
      '/constructorsMedia/gallery/movenpick/PERSP_Movenpick_Tsaghkadzor_LOBBY_2025_04_18_without_logo_9.jpg',
      '/constructorsMedia/gallery/movenpick/PERSP_Movenpick_Tsaghkadzor_LOBBY_2025_04_18_without_logo_10.jpg',
      '/constructorsMedia/gallery/movenpick/PERSP_Movenpick_Tsaghkadzor_LOBBY_2025_04_18_without_logo_11.jpg',
      '/constructorsMedia/gallery/movenpick/PERSP_Movenpick_Tsaghkadzor_LOBBY_2025_04_18_without_logo_12.jpg',
      '/constructorsMedia/gallery/movenpick/PERSP_Movenpick_Tsaghkadzor_LOBBY_2025_04_18_without_logo_13.jpg',
      '/constructorsMedia/gallery/movenpick/PERSP_Movenpick_Tsaghkadzor_LOBBY_2025_04_18_without_logo_14.jpg',
      '/constructorsMedia/gallery/movenpick/PERSP_Movenpick_Tsaghkadzor_LOBBY_2025_04_18_without_logo_15.jpg',
      '/constructorsMedia/gallery/movenpick/PERSP_Movenpick_Tsaghkadzor_LOBBY_2025_04_18_without_logo_17.jpg',
      '/constructorsMedia/gallery/movenpick/PERSP_Movenpick_Tsaghkadzor_LOBBY_2025_04_18_without_logo_19.jpg',
      '/constructorsMedia/gallery/movenpick/WhatsApp Image 2025-06-13 at 14.07.42.jpeg',
      '/constructorsMedia/gallery/movenpick/PERSP_Movenpick_Tsaghkadzor_LOBBY_2025_04_18_without_logo_18 (1).jpg',
      '/constructorsMedia/gallery/movenpick/PERSP_Movenpick_Tsaghkadzor_LOBBY_2025_04_18_without_logo_18.jpg',
      '/constructorsMedia/gallery/movenpick/PERSP_Movenpick_Tsaghkadzor_LOBBY_2025_04_18_without_logo_16.jpg',
      '/constructorsMedia/gallery/movenpick/PERSP_Movenpick_Tsaghkadzor_LOBBY_2025_04_18_without_logo_20.jpg',
      '/constructorsMedia/gallery/movenpick/PERSP_Movenpick_Tsaghkadzor_LOBBY_2025_04_18_without_logo_21.jpg',
      '/constructorsMedia/gallery/movenpick/PERSP_Movenpick_Tsaghkadzor_LOBBY_2025_04_18_without_logo_22.jpg',
      '/constructorsMedia/gallery/movenpick/WhatsApp Image 2025-06-13 at 14.07.43.jpeg',
      '/constructorsMedia/gallery/movenpick/WhatsApp Image 2025-06-13 at 14.07.43 (1).jpeg',
      '/constructorsMedia/gallery/movenpick/WhatsApp Image 2025-06-13 at 14.07.43 (2).jpeg',
      '/constructorsMedia/gallery/movenpick/WhatsApp Image 2025-06-13 at 14.07.43 (3).jpeg',
      '/constructorsMedia/gallery/movenpick/WhatsApp Image 2025-06-13 at 14.07.43 (4).jpeg',
    ],
    additionalInformation: [
      {
        id: '5',
        title: 'Delivery Time',
        value: '2026 December',
      },
      {
        id: '1',
        title: 'Floor Area',
        value: '43,50 sqm',
      },
      {
        id: '3',
        title: 'Floor',
        value: '11th',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Available',
      },
    ],
    details: [
      {
        id: '1',
        title: 'Floor Area',
        value: '43,50 sqm',
      },
      {
        id: '3',
        title: 'Floor',
        value: '11',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Available',
      },
    ],
    address: {
      name: '52 Saralanj str.',
    },
    numberOfUnits: 270,
    roomUrl: '/copia/constructors/16/3d',
    yoEstateUrl:
      'https://yoestate.me/en/collections/movenpick-resort-tsaghkadzor/nfts',
    price: { amount: '1,683,000', per: '1m²', currency: 'AMD' },
    // price: { amount: '538', per: '1m²', currency: 'FTN' },
  },
  {
    id: 'smart-group-construction',
    isCustom: true,
    showBooking: true,
    name: 'Smart Group Construction',
    motto: '',
    description: `Smart Group Construction is a new housing project that includes two townhouses and one separate smart-class home. The outside of each house will be fully finished. Inside, the layout, design, and renovation will be done based on the buyer’s personal taste and needs. The homes are designed to be comfortable, practical, and smart - perfect for modern everyday living.`,
    logo: '/constructorsMedia/thumbnails/smart-group-construction.jpg',
    coverImageUrl:
      '/constructorsMedia/coverImages/smart-group-construction.jpg',
    startDate: '',
    endDate: '',
    location: null,
    phone: '+374 98 30 65 90',
    gallery: ['/constructorsMedia/gallery/smart-group-construction/1.jpg'],
    additionalInformation: [
      {
        id: '1',
        title: 'Floor Area',
        value: '130 sqm',
      },
      {
        id: '2',
        title: 'Number of Rooms',
        value: '6',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Not available',
      },
    ],
    details: [
      {
        id: '1',
        title: 'Floor Area',
        value: '130 sqm',
      },
      {
        id: '2',
        title: 'Number of Rooms',
        value: '6',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Not available',
      },
    ],
    address: {
      name: 'Tsaghkunk 2nd street',
    },
    numberOfUnits: 270,
    roomUrl: '/copia/constructors/20/3d',
    yoEstateUrl:
      'https://yoestate.me/en/collections/smart-group-construction/nfts',
    price: { amount: '366,000', per: '1m²', currency: 'AMD' },
  },
  {
    id: 'novotel-tsaghkadzor-1',
    isCustom: true,
    showBooking: true,
    name: 'Novotel Tsaghkadzor 1',
    motto: '',
    description: `Novotel part of the premium-class Armenia’s most popular mountain resorts. offers a one room apartment as a strong real estate investment in Armenia. The project features spacious and comfortable apartments with good design, quality construction, and a pleasant living environment. Each apartment is linked to an NFT, giving investors direct ownership connected to a real asset.`,
    logo: '/constructorsMedia/thumbnails/novotel-tsaghkadzor-1.jpg',
    coverImageUrl: '/constructorsMedia/coverImages/novotel-tsaghkadzor-1.jpg',
    startDate: '',
    endDate: '',
    location: null,
    phone: '+374 95 89 78 37',
    gallery: [
      '/constructorsMedia/gallery/novotel-tsaghkadzor-1/22CBAE40-C99E-46B8-8DB5-9385D39FCC54.jpg',
    ],
    additionalInformation: [
      {
        id: '5',
        title: 'Delivery Time',
        value: '2026 July',
      },
      {
        id: '1',
        title: 'Floor Area',
        value: '26,83 sqm',
      },
      {
        id: '2',
        title: 'Number of Rooms',
        value: '1',
      },
      {
        id: '3',
        title: 'Floor',
        value: '3rd',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Available',
      },
    ],
    details: [
      {
        id: '1',
        title: 'Floor Area',
        value: '26,83 sqm',
      },
      {
        id: '2',
        title: 'Number of Rooms',
        value: '1',
      },
      {
        id: '3',
        title: 'Floor',
        value: '3rd',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Available',
      },
    ],
    address: {
      name: 'Tsakhkadzor, Saralandzh str. 1st, 5',
    },
    numberOfUnits: 270,
    roomUrl: '/copia/constructors/21/3d',
    yoEstateUrl:
      'https://yoestate.me/en/collections/novotel-tsaghkadzor-1/nfts',
    price: { amount: '1,380,000', per: '1m²', currency: 'AMD' },
  },
  {
    id: 'novotel-tsaghkadzor-2',
    isCustom: true,
    showBooking: true,
    name: 'Novotel Tsaghkadzor 2',
    motto: '',
    description: `Novotel part of the premium-class Armenia’s most popular mountain resorts. offers a one room apartment as a strong real estate investment in Armenia. The project features spacious and comfortable apartments with good design, quality construction, and a pleasant living environment. Each apartment is linked to an NFT, giving investors direct ownership connected to a real asset.`,
    logo: '/constructorsMedia/thumbnails/novotel-tsaghkadzor-2.jpg',
    coverImageUrl: '/constructorsMedia/coverImages/novotel-tsaghkadzor-2.jpg',
    startDate: '',
    endDate: '',
    location: null,
    phone: '+374 95 89 78 37',
    gallery: [
      '/constructorsMedia/gallery/novotel-tsaghkadzor-1/22CBAE40-C99E-46B8-8DB5-9385D39FCC54.jpg',
    ],
    additionalInformation: [
      {
        id: '5',
        title: 'Delivery Time',
        value: '2026 July',
      },
      {
        id: '1',
        title: 'Floor Area',
        value: '39,18 sqm',
      },
      {
        id: '2',
        title: 'Number of Rooms',
        value: '1',
      },
      {
        id: '3',
        title: 'Floor',
        value: '3rd',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Available',
      },
    ],
    details: [
      {
        id: '1',
        title: 'Floor Area',
        value: '39,18 sqm',
      },
      {
        id: '2',
        title: 'Number of Rooms',
        value: '1',
      },
      {
        id: '3',
        title: 'Floor',
        value: '3rd',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Available',
      },
    ],
    address: {
      name: 'Tsakhkadzor, Saralandzh str. 1st, 5',
    },
    numberOfUnits: 270,
    roomUrl: '/copia/constructors/22/3d',
    yoEstateUrl:
      'https://yoestate.me/en/collections/novotel-tsaghkadzor-2/nfts',
    price: { amount: '1,150,000', per: '1m²', currency: 'AMD' },
  },
  {
    id: 'novotel-tsaghkadzor-3',
    isCustom: true,
    showBooking: true,
    name: 'Novotel Tsaghkadzor 3',
    motto: '',
    description: `Novotel part of the premium-class Armenia’s most popular mountain resorts. offers a one room apartment as a strong real estate investment in Armenia. The project features spacious and comfortable apartments with good design, quality construction, and a pleasant living environment. Each apartment is linked to an NFT, giving investors direct ownership connected to a real asset.`,
    logo: '/constructorsMedia/thumbnails/novotel-tsaghkadzor-3.jpg',
    coverImageUrl: '/constructorsMedia/coverImages/novotel-tsaghkadzor-3.jpg',
    startDate: '',
    endDate: '',
    location: null,
    phone: '+374 95 89 78 37',
    gallery: [
      '/constructorsMedia/gallery/novotel-tsaghkadzor-1/22CBAE40-C99E-46B8-8DB5-9385D39FCC54.jpg',
    ],
    additionalInformation: [
      {
        id: '5',
        title: 'Delivery Time',
        value: '2026 July',
      },
      {
        id: '1',
        title: 'Floor Area',
        value: '43,34 sqm',
      },
      {
        id: '2',
        title: 'Number of Rooms',
        value: '1',
      },
      {
        id: '3',
        title: 'Floor',
        value: '3rd',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Available',
      },
    ],
    details: [
      {
        id: '1',
        title: 'Floor Area',
        value: '43,34 sqm',
      },
      {
        id: '2',
        title: 'Number of Rooms',
        value: '1',
      },
      {
        id: '3',
        title: 'Floor',
        value: '3rd',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Available',
      },
    ],
    address: {
      name: 'Tsakhkadzor, Saralandzh str. 1st, 5',
    },
    numberOfUnits: 270,
    roomUrl: '/copia/constructors/23/3d',
    yoEstateUrl:
      'https://yoestate.me/en/collections/novotel-tsaghkadzor-3/nfts',
    price: { amount: '1,130,000', per: '1m²', currency: 'AMD' },
  },
  {
    id: 'novotel-tsaghkadzor-4',
    isCustom: true,
    showBooking: true,
    name: 'Novotel Tsaghkadzor 4',
    motto: '',
    description: `Novotel part of the premium-class Armenia’s most popular mountain resorts. offers a two room apartment as a strong real estate investment in Armenia. The project features spacious and comfortable apartments with good design, quality construction, and a pleasant living environment. Each apartment is linked to an NFT, giving investors direct ownership connected to a real asset.`,
    logo: '/constructorsMedia/thumbnails/novotel-tsaghkadzor-4.jpg',
    coverImageUrl: '/constructorsMedia/coverImages/novotel-tsaghkadzor-4.jpg',
    startDate: '',
    endDate: '',
    location: null,
    phone: '+374 95 89 78 37',
    gallery: [
      '/constructorsMedia/gallery/novotel-tsaghkadzor-1/22CBAE40-C99E-46B8-8DB5-9385D39FCC54.jpg',
    ],
    additionalInformation: [
      {
        id: '5',
        title: 'Delivery Time',
        value: '2026 July',
      },
      {
        id: '1',
        title: 'Floor Area',
        value: '47,39 sqm',
      },
      {
        id: '2',
        title: 'Number of Rooms',
        value: '2',
      },
      {
        id: '3',
        title: 'Floor',
        value: '3rd',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Available',
      },
    ],
    details: [
      {
        id: '1',
        title: 'Floor Area',
        value: '47,39 sqm',
      },
      {
        id: '2',
        title: 'Number of Rooms',
        value: '2',
      },
      {
        id: '3',
        title: 'Floor',
        value: '3rd',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Available',
      },
    ],
    address: {
      name: 'Tsakhkadzor, Saralandzh str. 1st, 5',
    },
    numberOfUnits: 270,
    roomUrl: '/copia/constructors/24/3d',
    yoEstateUrl:
      'https://yoestate.me/en/collections/novotel-tsaghkadzor-4/nfts',
    price: { amount: '1,130,000', per: '1m²', currency: 'AMD' },
  },
  {
    id: 'novotel-tsaghkadzor-5',
    isCustom: true,
    showBooking: true,
    name: 'Novotel Tsaghkadzor 5',
    motto: '',
    description: `Novotel part of the premium-class Armenia’s most popular mountain resorts. offers a two room apartment as a strong real estate investment in Armenia. The project features spacious and comfortable apartments with good design, quality construction, and a pleasant living environment. Each apartment is linked to an NFT, giving investors direct ownership connected to a real asset.`,
    logo: '/constructorsMedia/thumbnails/novotel-tsaghkadzor-5.jpg',
    coverImageUrl: '/constructorsMedia/coverImages/novotel-tsaghkadzor-5.jpg',
    startDate: '',
    endDate: '',
    location: null,
    phone: '+374 95 89 78 37',
    gallery: [
      '/constructorsMedia/gallery/novotel-tsaghkadzor-1/22CBAE40-C99E-46B8-8DB5-9385D39FCC54.jpg',
    ],
    additionalInformation: [
      {
        id: '5',
        title: 'Delivery Time',
        value: '2026 July',
      },
      {
        id: '1',
        title: 'Floor Area',
        value: '56,79 sqm',
      },
      {
        id: '2',
        title: 'Number of Rooms',
        value: '2',
      },
      {
        id: '3',
        title: 'Floor',
        value: '3rd',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Available',
      },
    ],
    details: [
      {
        id: '1',
        title: 'Floor Area',
        value: '56,79 sqm',
      },
      {
        id: '2',
        title: 'Number of Rooms',
        value: '2',
      },
      {
        id: '3',
        title: 'Floor',
        value: '3rd',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Available',
      },
    ],
    address: {
      name: 'Tsakhkadzor, Saralandzh str. 1st, 5',
    },
    numberOfUnits: 270,
    roomUrl: '/copia/constructors/25/3d',
    yoEstateUrl:
      'https://yoestate.me/en/collections/novotel-tsaghkadzor-5/nfts',
    price: { amount: '1,120,000', per: '1m²', currency: 'AMD' },
  },
  {
    id: 'top-buildings',
    isCustom: true,
    showBooking: true,
    name: 'Top Buildings',
    motto: '',
    description: `Top Buildings consists of a total of 18 floors- 16 above ground and 2 underground. It features high-quality aluminum curtain wall windows, two separate entrances, and is equipped with two premium elevators. The exterior is clad in natural stone, providing both durability and an elegant appearance. At the rear of the building, there is a courtyard with a playground, offering a comfortable and safe environment for families and children.`,
    logo: '/constructorsMedia/thumbnails/top-buildings.jpg',
    coverImageUrl: '/constructorsMedia/coverImages/top-buildings.jpg',
    startDate: '',
    endDate: '',
    location: null,
    phone: '+374 33 58 33 33',
    gallery: [
      '/constructorsMedia/gallery/top-buildings/IMG_9972.JPG',
      '/constructorsMedia/gallery/top-buildings/IMG_9974.JPG',
    ],
    additionalInformation: [
      {
        id: '5',
        title: 'Delivery Time',
        value: '2026 June',
      },
      {
        id: '1',
        title: 'Floor Area',
        value: '127,8 sqm',
      },
      {
        id: '2',
        title: 'Number of Rooms',
        value: '5',
      },
      {
        id: '3',
        title: 'Floor',
        value: '15th',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Not available',
      },
    ],
    details: [
      {
        id: '1',
        title: 'Floor Area',
        value: '127,8 sqm',
      },
      {
        id: '2',
        title: 'Number of Rooms',
        value: '5',
      },
      {
        id: '3',
        title: 'Floor',
        value: '15th',
      },
      {
        id: '4',
        title: 'Income tax refund',
        value: 'Not available',
      },
    ],
    address: {
      name: '9/2 Ashkhabad Street, Avan Administrative District',
    },
    numberOfUnits: 270,
    roomUrl: '/copia/constructors/26/3d',
    yoEstateUrl: 'https://yoestate.me/en/collections/top-buildings/nfts',
    price: { amount: '695,000', per: '1m²', currency: 'AMD' },
  },
  // {
  //   id: 'hrazdan-park-1',
  //   isCustom: true,
  //   showBooking: true,
  //   name: 'Hrazdan Park 1',
  //   motto: '',
  //   description:
  //     'Thanks to the complex’s proper location and positional attractiveness, the offered apartments have the necessary natural lighting, required sunlight hours, and wonderful views. The proposed residential complex advantageously stands out with its unique combination of classic and contemporary styles, high seismic resistance complying with modern urban planning standards, and comfortable apartment designs. The building has 15 above-ground floors, with public service areas located on the first floor. The building includes 16 underground parking spaces, and installed high-quality passenger elevators (up to 8 people) and freight elevators (up to 12 people) will also serve the mentioned parking spaces. The building will operate surveillance and fire alarm systems, security service, emergency power supply and water supply, internet connection, and cable television.',
  //   logo: '/constructorsMedia/thumbnails/hrazdan-park-1.jpg',
  //   coverImageUrl: '/constructorsMedia/coverImages/hrazdan-park-1.jpg',
  //   startDate: '06/26/2023',
  //   endDate: '06/26/2026',
  //   location: null,
  //   phone: '+374 60 38 03 80',
  //   gallery: [],
  //   additionalInformation: [
  //     {
  //       id: '5',
  //       title: 'Construction Time',
  //       value: '2023 June - 2026 June',
  //     },
  //     {
  //       id: '1',
  //       title: 'Floor Area',
  //       value: '157,88 sqm',
  //     },
  //     {
  //       id: '2',
  //       title: 'Number of Rooms',
  //       value: '5',
  //     },
  //     {
  //       id: '3',
  //       title: 'Floor',
  //       value: '15th',
  //     },
  //     {
  //       id: '4',
  //       title: 'Income tax refund',
  //       value: 'Available',
  //     },
  //   ],
  //   details: [
  //     {
  //       id: '1',
  //       title: 'Floor Area',
  //       value: '157,88 sqm',
  //     },
  //     {
  //       id: '2',
  //       title: 'Number of Rooms',
  //       value: '5',
  //     },
  //     {
  //       id: '3',
  //       title: 'Floor',
  //       value: '15th',
  //     },
  //     {
  //       id: '4',
  //       title: 'Income tax refund',
  //       value: 'Available',
  //     },
  //   ],
  //   address: {
  //     name: 'Sahmanadrutyun Square, 28/5 ',
  //   },
  //   numberOfUnits: 270,
  //   roomUrl: '/copia/constructors/31/3d',
  //   yoEstateUrl: 'https://yoestate.me/en/collections/hrazdan-park-1/nfts',
  //   price: { amount: '420,000', per: '1m²', currency: 'AMD' },
  // },
  // {
  //   id: 'hrazdan-park-2',
  //   isCustom: true,
  //   showBooking: true,
  //   name: 'Hrazdan Park 2',
  //   motto: '',
  //   description:
  //     'Thanks to the complex’s proper location and positional attractiveness, the offered apartments have the necessary natural lighting, required sunlight hours, and wonderful views. The proposed residential complex advantageously stands out with its unique combination of classic and contemporary styles, high seismic resistance complying with modern urban planning standards, and comfortable apartment designs. The building has 15 above-ground floors, with public service areas located on the first floor. The building includes 16 underground parking spaces, and installed high-quality passenger elevators (up to 8 people) and freight elevators (up to 12 people) will also serve the mentioned parking spaces. The building will operate surveillance and fire alarm systems, security service, emergency power supply and water supply, internet connection, and cable television.',
  //   logo: '/constructorsMedia/thumbnails/hrazdan-park-1.jpg',
  //   coverImageUrl: '/constructorsMedia/coverImages/hrazdan-park-1.jpg',
  //   startDate: '06/26/2023',
  //   endDate: '06/26/2026',
  //   location: null,
  //   phone: '+374 60 38 03 80',
  //   gallery: [],
  //   additionalInformation: [
  //     {
  //       id: '5',
  //       title: 'Construction Time',
  //       value: '2023 June - 2026 June',
  //     },
  //     {
  //       id: '1',
  //       title: 'Floor Area',
  //       value: '128,72 sqm',
  //     },
  //     {
  //       id: '2',
  //       title: 'Number of Rooms',
  //       value: '4',
  //     },
  //     {
  //       id: '3',
  //       title: 'Floor',
  //       value: '15th',
  //     },
  //     {
  //       id: '4',
  //       title: 'Income tax refund',
  //       value: 'Available',
  //     },
  //   ],
  //   details: [
  //     {
  //       id: '1',
  //       title: 'Floor Area',
  //       value: '128,72 sqm',
  //     },
  //     {
  //       id: '2',
  //       title: 'Number of Rooms',
  //       value: '4',
  //     },
  //     {
  //       id: '3',
  //       title: 'Floor',
  //       value: '15th',
  //     },
  //     {
  //       id: '4',
  //       title: 'Income tax refund',
  //       value: 'Available',
  //     },
  //   ],
  //   address: {
  //     name: 'Sahmanadrutyun Square, 28/5 ',
  //   },
  //   numberOfUnits: 270,
  //   roomUrl: '/copia/constructors/32/3d',
  //   yoEstateUrl: 'https://yoestate.me/en/collections/hrazdan-park-2/nfts',
  //   price: { amount: '420,000', per: '1m²', currency: 'AMD' },
  // },
  // {
  //   id: 'hrazdan-park-3',
  //   isCustom: true,
  //   showBooking: true,
  //   name: 'Hrazdan Park 3',
  //   motto: '',
  //   description:
  //     'Thanks to the complex’s proper location and positional attractiveness, the offered apartments have the necessary natural lighting, required sunlight hours, and wonderful views. The proposed residential complex advantageously stands out with its unique combination of classic and contemporary styles, high seismic resistance complying with modern urban planning standards, and comfortable apartment designs. The building has 15 above-ground floors, with public service areas located on the first floor. The building includes 16 underground parking spaces, and installed high-quality passenger elevators (up to 8 people) and freight elevators (up to 12 people) will also serve the mentioned parking spaces. The building will operate surveillance and fire alarm systems, security service, emergency power supply and water supply, internet connection, and cable television.',
  //   logo: '/constructorsMedia/thumbnails/hrazdan-park-3.jpg',
  //   coverImageUrl: '/constructorsMedia/coverImages/hrazdan-park-1.jpg',
  //   startDate: '06/26/2023',
  //   endDate: '06/26/2026',
  //   location: null,
  //   phone: '+374 60 38 03 80',
  //   gallery: [],
  //   additionalInformation: [
  //     {
  //       id: '5',
  //       title: 'Construction Time',
  //       value: '2023 June - 2026 June',
  //     },
  //     {
  //       id: '1',
  //       title: 'Floor Area',
  //       value: '164,53 sqm',
  //     },
  //     {
  //       id: '2',
  //       title: 'Number of Rooms',
  //       value: '5',
  //     },
  //     {
  //       id: '3',
  //       title: 'Floor',
  //       value: '15th',
  //     },
  //     {
  //       id: '4',
  //       title: 'Income tax refund',
  //       value: 'Available',
  //     },
  //   ],
  //   details: [
  //     {
  //       id: '1',
  //       title: 'Floor Area',
  //       value: '164,53 sqm',
  //     },
  //     {
  //       id: '2',
  //       title: 'Number of Rooms',
  //       value: '5',
  //     },
  //     {
  //       id: '3',
  //       title: 'Floor',
  //       value: '15th',
  //     },
  //     {
  //       id: '4',
  //       title: 'Income tax refund',
  //       value: 'Available',
  //     },
  //   ],
  //   address: {
  //     name: 'Sahmanadrutyun Square, 28/5 ',
  //   },
  //   numberOfUnits: 270,
  //   roomUrl: '/copia/constructors/33/3d',
  //   yoEstateUrl: 'https://yoestate.me/en/collections/hrazdan-park-3/nfts',
  //   price: { amount: '420,000', per: '1m²', currency: 'AMD' },
  // },
  {
    id: 'edge-residence',
    isCustom: true,
    showBooking: true,
    name: 'Edge Residence',
    motto: '',
    description: '',
    logo: '/constructorsMedia/thumbnails/edge-residence.jpg',
    coverImageUrl: '/constructorsMedia/coverImages/edge-residence.jpg',
    startDate: '',
    endDate: '',
    location: null,
    phone: '',
    gallery: [],
    additionalInformation: [
      {
        id: '1',
        title: 'Floor Area',
        value: '36,82 sqm',
      },
    ],
    details: [
      {
        id: '1',
        title: 'Floor Area',
        value: '36,82 sqm',
      },
    ],
    address: {
      name: '',
    },
    numberOfUnits: 270,
    roomUrl: '/copia/constructors/27/3d',
    yoEstateUrl: 'https://yoestate.me/en/collections/edge-residence/nfts',
    price: { amount: '3,350,000', per: '1m²', currency: 'AMD' },
  },
  {
    id: 'the-edge-signature',
    isCustom: true,
    showBooking: true,
    name: 'The Edge Signature',
    motto: '',
    description: '',
    logo: '/constructorsMedia/thumbnails/the-edge-signature.jpg',
    coverImageUrl: '/constructorsMedia/coverImages/the-edge-signature.jpg',
    startDate: '',
    endDate: '',
    location: null,
    phone: '',
    gallery: [],
    additionalInformation: [
      {
        id: '1',
        title: 'Floor Area',
        value: '36,61 sqm',
      },
    ],
    details: [
      {
        id: '1',
        title: 'Floor Area',
        value: '36,61 sqm',
      },
    ],
    address: {
      name: '',
    },
    numberOfUnits: 270,
    roomUrl: '/copia/constructors/28/3d',
    yoEstateUrl: 'https://yoestate.me/en/collections/the-edge-signature/nfts',
    price: { amount: '3,370,000', per: '1m²', currency: 'AMD' },
  },
  {
    id: 'edge-tower-elite',
    isCustom: true,
    showBooking: true,
    name: 'Edge Tower Elite',
    motto: '',
    description: '',
    logo: '/constructorsMedia/thumbnails/edge-tower-elite.jpg',
    coverImageUrl: '/constructorsMedia/coverImages/edge-tower-elite.jpg',
    startDate: '',
    endDate: '',
    location: null,
    phone: '',
    gallery: [],
    additionalInformation: [
      {
        id: '1',
        title: 'Floor Area',
        value: '35,43 sqm',
      },
    ],
    details: [
      {
        id: '1',
        title: 'Floor Area',
        value: '35,43 sqm',
      },
    ],
    address: {
      name: '',
    },
    numberOfUnits: 270,
    roomUrl: '/copia/constructors/29/3d',
    yoEstateUrl: 'https://yoestate.me/en/collections/edge-tower-elite/nfts',
    price: { amount: '3,470,000', per: '1m²', currency: 'AMD' },
  },
  {
    id: 'address-jbr',
    isCustom: true,
    showBooking: true,
    name: 'Address JBR',
    motto: '',
    description: '',
    logo: '/constructorsMedia/thumbnails/address-jbr.jpg',
    coverImageUrl: '/constructorsMedia/coverImages/address-jbr.jpg',
    startDate: '',
    endDate: '',
    location: null,
    phone: '',
    gallery: [],
    additionalInformation: [],
    details: [],
    address: {
      name: '',
    },
    numberOfUnits: 270,
    roomUrl: '/copia/constructors/30/3d',
    yoEstateUrl: 'https://yoestate.me/en/collections/address-jbr/nfts',
  },
  {
    id: 1,
    excludeFromList: true,
    address: {
      id: 3448,
      name: 'G. Chaush St 60',
    },
    name: 'New House Resident',
    file: null,
    logo: 'https://fv-media.storage.googleapis.com/real_estate_constructor_logo/3d7508cc8953d06e1958763faf1c19c0.png',
    description: '',
    startedPrice: null,
    expireDate: '',
    nftQuantity: null,
    issuedBy: null,
    reward: null,
    websiteLink: '',
    rewardPercentage: null,
    startDate: '2001-05-20',
    endDate: '2001-03-20',
    floorArea: 53,
    numberOfRooms: 1,
    numberOfUnits: 5,
    location: null,
    additionalInformation: [
      {
        id: '1',
        title: 'Number of Units',
        value: '5',
      },
    ],
    roomUrl: '/copia/constructors/1/3d',
    gallery: [],
    yoEstateUrl: '',
  },
  {
    id: 2,
    excludeFromList: true,
    address: {
      id: 10357,
      name: 'Al Sufouh - Al Sufouh 2 - Dubai - United Arab Emirates',
    },
    name: 'The Edge Tower',
    file: null,
    logo: 'https://fv-media.storage.googleapis.com/real_estate_constructor_logo/6b6dbf92811fe7c026e2db525cde5084.png',
    description:
      'At the end of the collection period, your purchased NFT will be burned, and you will receive 30% of the NFT’s starting price.',
    startedPrice: null,
    expireDate: '',
    nftQuantity: null,
    issuedBy: 1,
    reward: 2,
    websiteLink: '',
    rewardPercentage: null,
    startDate: '2025-03-01',
    endDate: '2025-03-31',
    floorArea: 1000,
    numberOfRooms: 250,
    numberOfUnits: 3,
    gallery: [],
    additionalInformation: [
      {
        id: '1',
        title: 'Reward',
        value: 'Weekly',
      },
      {
        id: '2',
        title: 'Start Date',
        value: '01 Mar 2025',
      },
      {
        id: '3',
        title: 'End Date',
        value: '31 Mar 2025',
      },
      {
        id: '1',
        title: 'Number of Units',
        value: '3',
      },
    ],
    roomUrl: '/copia/constructors/2/3d',
    yoEstateUrl: 'https://yoestate.me/collections/the-edge-tower/nfts',
  },
  {
    id: 3,
    excludeFromList: true,
    address: {
      id: 10236,
      name: 'Tsaxkadzor, Saralanj 1-in poxoc, pakuxi 5',
    },
    name: 'Novotel Tsaghkadzor',
    file: null,
    logo: 'https://fv-media.storage.googleapis.com/real_estate_constructor_logo/3dd9382417b5b2c7f50a3edbeedfa428.png',
    description: '',
    startedPrice: null,
    expireDate: '',
    nftQuantity: null,
    issuedBy: null,
    reward: null,
    websiteLink: '',
    rewardPercentage: null,
    startDate: '2025-03-21',
    endDate: '2025-03-31',
    floorArea: 1,
    numberOfRooms: 2,
    numberOfUnits: 2,
    gallery: [],
    additionalInformation: [
      {
        id: '1',
        title: 'Number of Units',
        value: '2',
      },
    ],
    roomUrl: '/copia/constructors/3/3d',
    yoEstateUrl: '',
  },
  {
    id: 4,
    excludeFromList: true,
    address: {
      id: 10295,
      name: 'Hayat Island - Mina Al Arab - Ras Al Khaimah - United Arab Emirates',
    },
    name: 'Intercontinental Ras Al Khaimah',
    file: null,
    logo: 'https://fv-media.storage.googleapis.com/real_estate_constructor_logo/8aff72087d67601942f0c0fc4cffb2ae.png',
    description:
      'At the end of the collection period, your purchased NFT will be burned, and you will receive 30% of the NFT’s starting price.',
    startedPrice: null,
    expireDate: '',
    nftQuantity: null,
    issuedBy: 1,
    reward: 2,
    websiteLink: '',
    rewardPercentage: null,
    startDate: '2025-03-27',
    endDate: '2025-03-28',
    floorArea: 1,
    numberOfRooms: 2,
    numberOfUnits: 2,
    gallery: [],
    additionalInformation: [
      {
        id: '1',
        title: 'Reward',
        value: 'Weekly',
      },
      {
        id: '2',
        title: 'Start Date',
        value: '27 Mar 2025',
      },
      {
        id: '3',
        title: 'End Date',
        value: '28 Mar 2025',
      },
      {
        id: '4',
        title: 'Number of Units',
        value: '2',
      },
    ],
    roomUrl: '/copia/constructors/4/3d',
    yoEstateUrl: '',
  },
];

export default CONSTRUCTORS;
